import React from 'react';
import useRemindersSearch from '../../hooks/use-reminders-search';
import useReminderActions from '../../hooks/use-reminder-actions';
import ReminderEditModal from '../modals/reminder-edit-modal';
import ReminderRescheduleModal from '../modals/reminder-reschedule-modal';
import RemindersSummaryView from './reminders-summary-view';

type RemindersSummaryContainerProps = {
  tripRequestId: string;
  travelerId?: string;
  showYear?: boolean;
  showFilters?: boolean;
  emptyMessage?: string;
};

const RemindersSummaryContainer = ({
  tripRequestId,
  travelerId,
  showYear = false,
  showFilters = false,
  emptyMessage,
}: RemindersSummaryContainerProps) => {
  // Fetch reminders for this trip request or traveler (open and completed, excluding canceled)
  const {
    reminders,
    isLoading,
    refetch,
  } = useRemindersSearch({
    tripRequestId,
    travelerId,
    statusFilter: 'openAndCompleted',
    limit: 100,
  });

  // Use the reminder actions hook
  const {
    create,
    edit,
    duplicate,
    reschedule,
    toggleComplete,
    dismiss,
    togglingCompleteId,
    editModalProps,
    rescheduleModalProps,
  } = useReminderActions({
    refetch,
    tripRequestId,
    travelerId,
    excludeAllAssignee: true,
  });

  return (
    <>
      <RemindersSummaryView
        reminders={reminders}
        isLoading={isLoading}
        togglingCompleteId={togglingCompleteId}
        showYear={showYear}
        showFilters={showFilters}
        emptyMessage={emptyMessage}
        onAddReminder={create}
        onEditReminder={edit}
        onDuplicateReminder={duplicate}
        onRescheduleReminder={reschedule}
        onToggleComplete={toggleComplete}
        onDismissReminder={dismiss}
      />

      {/* Edit/Create Modal */}
      <ReminderEditModal
        open={editModalProps.open}
        onClose={editModalProps.onClose}
        onSave={editModalProps.onSave}
        ticket={editModalProps.ticket}
        defaultValues={editModalProps.defaultValues}
        assignees={editModalProps.assignees}
        isNew={editModalProps.isNew}
        tripRequests={editModalProps.tripRequests}
        hasTripRequestContext={editModalProps.hasTripRequestContext}
        countryCodes={editModalProps.countryCodes}
        isLoadingTripRequests={editModalProps.isLoadingTripRequests}
        duplicateTripRequestId={editModalProps.duplicateTripRequestId}
      />

      {/* Reschedule Modal */}
      <ReminderRescheduleModal
        open={rescheduleModalProps.open}
        onClose={rescheduleModalProps.onClose}
        onSave={rescheduleModalProps.onSave}
        currentDueAt={rescheduleModalProps.currentDueAt}
      />
    </>
  );
};

export default RemindersSummaryContainer;
